export default "__VITE_ASSET__BfDELJYQ__"